import { Avatar, Box, IconButton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Grid } from '@mui/system';
import * as Actions from 'features/frontoffice/actions/actions';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'store/store';
import { capitalizeFirstChar } from 'utils/common';
import CustomTooltip from 'common/customTooltip';

const popperProps = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset : [-17 , -5]
      }
    }
  ]
};

const useStyles = makeStyles((theme) => ({
  avatar: {
    color: ({ onSideNavBar }) => onSideNavBar ? '#FFF' : '#2F54A5',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    backgroundColor: ({ onSideNavBar }) => onSideNavBar ? '#001A47' : '#ffffff',
  }
}));

const userInfoSx = {
  color: '#FFF',
  fontSize: '14px',
  lineHeight: '10px',
};

const UserMenu = ({ onSideNavBar }) => {
  const classes = useStyles({ onSideNavBar });
  const firstName = useSelector((state) => state.user.firstName);
  const lastName = useSelector((state) => state.user.lastName);
  const email = useSelector((state) => state.user.email);

  const displayFirstName = capitalizeFirstChar(firstName);
  const displayLastName = capitalizeFirstChar(lastName);

  useEffect(() => {
    store.dispatch(Actions.globalConfig());
  }, []);

  const userInfo = (
    <Grid container direction="column" gap={1.5}>
      <Typography sx={{ ...userInfoSx, fontFamily: 'Rubik', fontWeight: '600', letterSpacing: '0.14px' }}>
        {`${displayFirstName} ${displayLastName}`}
      </Typography>
      <Typography sx={{ ...userInfoSx, fontFamily: 'Noto Sans', fontWeight: '400' }}>
        {email}
      </Typography>
    </Grid>
  );

  return (
    <Box
      sx={{
        display: onSideNavBar ? 'flex' : {
          xs: 'none',
          sm: 'none',
          md: 'block'
        },
        ...(onSideNavBar && { flexDirection: 'row', alignItems: 'center', gap: '12px' })
      }}>
      <CustomTooltip 
        title={userInfo}
        borderRadius="8px 0px 8px 8px"
        popperProps={popperProps}
        padding= "16px"
      >
        <IconButton
          aria-label="User profile menu"
          sx={{
            border: onSideNavBar ? '1px solid #FFF' : '1px solid #2F54A5',
            width: 44,
            height: 44,
            padding: 1,
            aspectRatio: '1/1',
            borderRadius: '24px',
            '&:hover': {
              backgroundColor: onSideNavBar ? '#001A47' : '#D8E6FF',
              border: onSideNavBar ? '1px solid #FFF' : '1px solid #001A47',
              '& .MuiAvatar-root': {
                backgroundColor: onSideNavBar ? '#001A47' : '#D8E6FF',
                color: onSideNavBar ? '#FFF' : '#001A47',
              },
            },
          }}
        >
          <Avatar className={classes.avatar}>
            {firstName && firstName.charAt(0).toUpperCase()}
            {lastName && lastName.charAt(0).toUpperCase()}
          </Avatar>
        </IconButton>
      </CustomTooltip>
      {onSideNavBar && (userInfo)}
    </Box>
  );
};

export default UserMenu;
